import CookieManager from '../src/lib/CookiesManager'
import { API_BASE_URL } from './api'

export const deleteAllUserData = async (userId: string) => {
  try {
    const token = CookieManager.getToken()
    if (!token) {
      throw new Error('No token found')
    }

    const response = await fetch(`${API_BASE_URL}/user/${userId}`, {
      method: 'GET',
      headers: {
        Authorization: `Bearer ${token}`,
      },
    })
    if (response.ok) {
      console.log('User is authorized to delete their account')
    }
    if (!response.ok) {
      throw new Error('You are not authorized to delete this account')
    }

    await deleteAnnounce(userId, token)
    await deleteEvent(userId, token)
    await deleteEstablishment(userId, token)
    await deleteProfile(userId, token)
    await deleteUser(userId, token)
  } catch (err) {
    console.error('Error deleting user data:', err)
    throw err
  }
}

const deleteAnnounce = async (userId: string, token: string) => {
  console.log('Deleting user announce...')
  await fetch(`${API_BASE_URL}/user/${userId}/announce`, {
    method: 'DELETE',
    headers: {
      Authorization: `Bearer ${token}`,
    },
  })
}

const deleteEvent = async (userId: string, token: string) => {
  console.log('Deleting user events...')
  await fetch(`${API_BASE_URL}/user/${userId}/event`, {
    method: 'DELETE',
    headers: {
      Authorization: `Bearer ${token}`,
    },
  })
}

const deleteEstablishment = async (userId: string, token: string) => {
  console.log('Deleting user establishments...')
  await fetch(`${API_BASE_URL}/user/${userId}/establishment`, {
    method: 'DELETE',
    headers: {
      Authorization: `Bearer ${token}`,
    },
  })
}

const deleteProfile = async (userId: string, token: string) => {
  console.log('Deleting user profile...')
  await fetch(`${API_BASE_URL}/user/${userId}/profile`, {
    method: 'DELETE',
    headers: {
      Authorization: `Bearer ${token}`,
    },
  })
}

const deleteUser = async (userId: string, token: string) => {
  console.log('Deleting user...')
  await fetch(`${API_BASE_URL}/user/${userId}`, {
    method: 'DELETE',
    headers: {
      Authorization: `Bearer ${token}`,
    },
  })
}
